export default function commentsReducer(commentsContext, action) {
  switch (action.type) {
    case 'update': {
      return {
        ...commentsContext,
        ...action.payload
      }
    }
    default: {
      throw Error('Unknown action: ' + action.type);
    }
  }
}
